import { render, staticRenderFns } from "./BreakdownAssist.vue?vue&type=template&id=e0caa9da&"
import script from "./BreakdownAssist.vue?vue&type=script&lang=js&"
export * from "./BreakdownAssist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports